var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),_c('v-popup'),_vm._v(" "),_c('msg',{ref:"msg"}),_vm._v(" "),_c('v-wxts'),_vm._v(" "),_c('v-bar-scan',{ref:"zoom"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-016b902e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1508
// module chunks = 379